//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'SkillsEmptyState',
  props: {
    main: {
      type: String,
      default: '',
    },
    hideText: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    mainCopy() {
      return (
        this.main ||
        this.$t('questionaryProject.validateSkills.emptyState.main')
      )
    },
  },
}
